import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';

export const useTree = (format: 'nested' | 'edges' = 'nested', rootId?: string) => {
    return useQuery({
        queryKey: ['tree', format, rootId],
        queryFn: async () => {
            const params = new URLSearchParams();
            if (rootId) params.append('rootId', rootId);
            params.append('format', format);

            const { data } = await apiClient.get(`/tree?${params}`);
            return data;
        },
    });
};
